import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, TitleH2, TitleH4 } from "components/generic";
import { IHelpWidget } from "interfaces/interfaces";
import { CONTACT_ROUTE } from "utils/constants";
import { StyledDiv } from "./styles";
import { useTranslation } from "react-i18next";

export const HelpWidget: React.FC<IHelpWidget> = ({ title, text, btnText }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation("home");
  return (
    <StyledDiv border align="center" style={{ padding: "24px" }}>
      <TitleH2>{title}</TitleH2>
      <TitleH4 m="8px 0 32px 0">{text.join(".\n")}</TitleH4>
      <Button
        normal
        onClick={() => navigate(`/${i18n.language}${CONTACT_ROUTE.slice(5)}`)}
      >
        {btnText}
      </Button>
    </StyledDiv>
  );
};
